import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";
import { workspaceKey } from "../api/hooks/useWorkspace";
import type { Workspace } from "../api/types";

interface UpdateWorkspaceInput {
  readonly name?: string;
  readonly slug?: string;
}

export function useUpdateWorkspace(slug: string) {
  const qc = useQueryClient();
  return useMutation<Workspace, ApiError, UpdateWorkspaceInput>({
    mutationFn: (input) =>
      apiFetch<Workspace>(`/api/ws/${slug}`, { method: "PATCH", body: input }),
    onSuccess: (ws) => {
      // Invalidate list and old/new workspace detail queries
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
      qc.invalidateQueries({ queryKey: workspaceKey(slug) });
      if (ws.slug !== slug) {
        qc.invalidateQueries({ queryKey: workspaceKey(ws.slug) });
      }
    },
  });
}
